import styled, { css } from 'styled-components';

import {
    IconCloseOutline,
    IconReload,
    spaceMixin,
    Spacer,
    Text,
} from '@zillow/constellation';

export const StyledActionsContainerSpacer = styled(Spacer)`
    display: block;
`;

export const StyledIconCloseOutline = styled(IconCloseOutline)`
    display: inline-block;
    position: relative;
    margin-right: ${spaceMixin('sm')};
    top: 2px;
`;

export const StyledIconReload = styled(IconReload)`
    display: inline-block;
    position: relative;
    margin-right: ${spaceMixin('sm')};
    top: 2px;
`;

export const StyledImgInfoDiv = styled.div`
    display: block;
    padding-top: ${spaceMixin('xs')};
    vertical-align: top;
    width: 100%;
    ${props => props.theme.ns().media.xl(css`
        padding-top: 0;
        display: inline-block;
        padding-left: ${spaceMixin('md')};
        width: calc(100% - 150px);
    `)};
    .img-btn-container {
        float: right;
        width: 145px;
    }
`;

export const StyledText = styled(Text)`
    margin-bottom: ${spaceMixin('xs')};
    display: block;
    cursor: pointer;
`;

export const StyledUploadedImgDiv = styled.div`
    display: block;
    position: relative;
    vertical-align: top;
    width: 100%;
    ${props => props.theme.ns().media.xl(css`
        display: inline-block;
        width: 150px;
    `)};
    img {
        border-radius: 4px;
        width: 100%;
    }
`;
